import { render, staticRenderFns } from "./CaldateChip.vue?vue&type=template&id=0917dfbb&scoped=true&"
import script from "./CaldateChip.vue?vue&type=script&lang=ts&"
export * from "./CaldateChip.vue?vue&type=script&lang=ts&"
import style0 from "./CaldateChip.vue?vue&type=style&index=0&id=0917dfbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0917dfbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
